import { defineMessages } from 'react-intl';

export const scope = 'app.components.SignedInRedirect';

export const messages = defineMessages({
  signOutToUseLink: {
    id: `${scope}.signOutToUseLink`,
    defaultMessage: "You're already signed in, so that link wasn't used. Sign out, then open the link again.",
  },
});
